module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkImportModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.importDataChecked) ? _c('div', [_c('p', [_vm._v("Enter the SurveyID and select your import file. Then click on 'Check Data'. The file will be checked and potential problems will be shown.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getSurveyDataAndCheckImportData()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sid),
      expression: "sid"
    }],
    attrs: {
      "type": "number",
      "name": "sid",
      "id": "sidInput",
      "placeholder": "SID",
      "required": ""
    },
    domProps: {
      "value": (_vm.sid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "checkImportFileInput",
      "type": "file",
      "accept": ".xlsx",
      "required": ""
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Check Data")])])]) : _vm._e(), _vm._v(" "), (_vm.importDataChecked && !_vm.importFinished) ? _c('div', [(!_vm.showUndefinedElements && _vm.invalidChecks.length == 0 && !_vm.showUndefinedQuestionChoices) ? _c('p', [_vm._v("No Problems found! Proceed with import by clicking 'Import'")]) : _vm._e(), _vm._v(" "), (_vm.showUndefinedElements || _vm.invalidChecks.length != 0 || _vm.showUndefinedQuestionChoices) ? _c('p', [_vm._v("The following problems have been identified:")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion"
  }, [(_vm.invalidChecks.length != 0) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionInvalidChecks"),
      expression: "`accordionInvalidChecks`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconInvalidChecks')
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Invalid Checks")]), _vm._v(" (" + _vm._s(_vm.invalidChecks.length) + ")")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconInvalidChecks"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionInvalidChecks"
    }
  }, _vm._l((_vm.invalidChecks), function(check) {
    return _c('div', {
      key: check.checkId
    }, [_c('p', [_vm._v("Row: " + _vm._s(check.row) + ", CheckID: " + _vm._s(check.checkId) + ", Message: " + _vm._s(check.msg))])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.showUndefinedElements) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionUndefinedElements"),
      expression: "`accordionUndefinedElements`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconUndefinedElements')
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Undefined Elements")]), _vm._v(" (" + _vm._s(_vm.undefinedElements.length) + ")")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconUndefinedElements"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionUndefinedElements"
    }
  }, _vm._l((_vm.undefinedElements), function(e) {
    return _c('div', {
      key: e.guid
    }, [_c('p', [_vm._v("Column: " + _vm._s(e.column) + ", GUID: " + _vm._s(e.guid))])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.showUndefinedQuestionChoices) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionUndefinedQuestionChoices"),
      expression: "`accordionUndefinedQuestionChoices`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconUndefinedQuestionChoices')
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Undefined Question Choices")]), _vm._v(" (" + _vm._s(_vm.undefinedQuestionChoices.length) + ")")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconUndefinedQuestionChoices"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionUndefinedQuestionChoices"
    }
  }, _vm._l((_vm.undefinedQuestionChoices), function(e, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v("Row: " + _vm._s(e.row) + ", Column: " + _vm._s(e.column) + ", CheckID: " + _vm._s(e.check) + ", GUID: " + _vm._s(e.guid))])])
  }), 0)], 1) : _vm._e()]), _vm._v(" "), (_vm.showUndefinedElements || _vm.invalidChecks.length != 0 || _vm.showUndefinedQuestionChoices) ? _c('p', [_vm._v("Do you want to proceed? Problematic elements will be skipped.")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.enableUpload()
    },
    on: {
      "click": function($event) {
        return _vm.saveSurveys()
      }
    }
  }, [_vm._v("\n            Import\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.importFinished) ? _c('div', [_c('p', [_vm._v("The import was finished.")]), _vm._v(" "), _c('p', [_vm._v("Start: " + _vm._s(_vm.importStart))]), _vm._v(" "), _c('p', [_vm._v("End: " + _vm._s(_vm.importEnd))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.failedRequests.length) + " check imports failed.")]), _vm._v(" "), _c('div', {
    staticClass: "accordion"
  }, [(_vm.showFailedRequests) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionFailedRequests"),
      expression: "`accordionFailedRequests`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconFailedRequests')
      }
    }
  }, [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Failed Requests")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconFailedRequests"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionFailedRequests"
    }
  }, _vm._l((_vm.failedRequests), function(e, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v("CheckID: " + _vm._s(e.check) + ", Time: " + _vm._s(e.time))])])
  }), 0)], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Close\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("CHECK IMPORT")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5c73b34","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckManagement/CheckImportModal.vue
// module id = 658
// module chunks = 1 2